<template>
  <b-card no-body class="mb-0">
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Hiển thị</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="showPerPage"
          />
          <label>dòng</label>
        </b-col>

        <!-- Search -->
        <!-- <b-col cols="12" md="6">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block"
              placeholder="Tìm kiếm..."
              @input="search"
            />
          </div>
        </b-col> -->
      </b-row>
    </div>
    <div class="px-2">
      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="dataTable"
        responsive
        :fields="fields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Không có dữ liệu"
        :sort-desc.sync="isSortDirDesc"
        table-class="vgt-table cs-table-info"
      >
        <!-- Column: User -->
        <!-- <template #cell(STT)="data"> {{ data.index + 1 }} </template> -->
        <template #cell(hoVaTen)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="url + data.item.avatar"
                :text="avatarText(data.value)"
                :variant="`light-${resolveUserRoleVariant(data.item.unitRole)}`"
                :to="{
                  name: 'canbocongchuc-thongtin',
                  params: { id: data.item.id },
                }"
              />
            </template>
            <b-link
              :to="{
                name: 'canbocongchuc-thongtin',
                params: { id: data.item.id },
              }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.value }}
            </b-link>
            <small class="text-muted">@{{ data.item.email }}</small>
          </b-media>
        </template>
        <template #cell(donVi)="data">
          <b-badge
            :variant="`light-${resolveUserStatusVariant(data.value.code)}`"
            class="text-capitalize"
          >
            <p class="truncate1 mb-0">{{ data.value.ten }}</p>
          </b-badge>
        </template>
        <template #cell(soCccd)="data">
          {{ data.value }}
        </template>
        <template #cell(ngaySinh)="data">
          {{ new Date(data.value) | moment("DD/MM/YYYY") }}
        </template>
        <template #cell(trangThaiHoSo)="data">
          <b-badge
            :variant="`light-${resolveUserStatusVariant(data.value.code)}`"
            class="text-capitalize"
            >{{ data.value.name }}</b-badge
          >
        </template>
        <template #cell(unitRole)="data">
          <b-badge
            :variant="`light-${resolveUserRoleVariant(data.value)}`"
            class="text-capitalize"
          >
            <p v-if="data.value" class="truncate1 mb-0">
              {{ data.value.name }}
            </p></b-badge
          >
        </template>

        <!-- Column: Actions -->
        <template #cell(action)="data">
          <b-button
            :to="{
              name: 'canbocongchuc-thongtin',
              params: { id: data.item.id },
            }"
            variant="flat-success"
            class="btn-icon"
          >
            <feather-icon icon="SendIcon" size="16" />
          </b-button>
        </template>
      </b-table>
    </div>

    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Hiển thị {{ dataMeta.from }} đến {{ dataMeta.to }} của
            {{ totalList }} dòng
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalList"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="pagination"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BCard,
  BButton,
  BCardBody,
  BCol,
  BRow,
  BTable,
  BDropdown,
  BDropdownItem,
  BAvatar,
  BMedia,
  BLink,
  BBadge,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { VueGoodTable } from "vue-good-table";
import useSetup from "./../useSetup";
import { integer } from "vee-validate/dist/rules";
import { ref } from "@vue/composition-api";

export default {
  components: {
    BCard,
    BCardBody,
    BFormGroup,
    BFormInput,
    BButton,
    VueGoodTable,
    BPagination,
    BFormSelect,
    BCol,
    BRow,
    BTable,
    vSelect,
    BDropdown,
    BDropdownItem,
    BAvatar,
    BMedia,
    BLink,
    BBadge,
  },
  props: {
    dataTable: {
      type: Array,
      required: true,
    },
    isLoaded: {
      type: Boolean,
      required: true,
    },
    totalList: { type: Number, required: true },
    dataMeta: { type: Object, required: true },
  },
  data() {
    return {
      isWait: false,
      pageLength: 10,
      dir: false,
      fields: [
        // {
        //   key: 'STT',
        //   label: 'STT',
        //   class: 'text-center',
        //   thStyle: 'width:50px',
        //   // tdStyle: "text-align: center;",
        // },
        {
          key: "hoVaTen",
          label: "Họ và tên",
          sortable: true,
        },
        {
          key: "donVi",
          label: "Cơ quan hiện tại",
          class: "",
          thStyle: "width:180px",
        },
        {
          key: "soCccd",
          label: "Số CCCD",
          class: "",
          thStyle: "width:150px",
        },
        {
          key: "ngaySinh",
          label: "Ngày sinh",
          class: "",
          thStyle: "width:150px",
        },
        {
          key: "trangThaiHoSo",
          label: "Trạng thái HS",
          class: "",
          thStyle: "width:150px",
        },
        {
          key: "unitRole",
          label: "Vai trò",
          class: "",
          thStyle: "width:100px",
        },
        {
          key: "action",
          label: "#",
          thStyle: "text-align:center; width:150px",
          tdClass: "",
        },
      ],
      url: process.env.VUE_APP_BASE_API + "/files/view/",
      searchTerm: "",
    };
  },
  methods: {
    pagination(val) {
      this.$emit("update-pagination", val);
    },
    showPerPage(val) {
      this.$emit("update-perpage", val);
    },
    search(val) {
      console.log(val);
      this.$emit("update-searchquery", val);
    },
  },
  setup(props, { emit }) {
    const {
      refUserListTable,
      getDataList,
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refetchData,
    } = useSetup();
    const resolveUserRoleVariant = (role) => {
      if (role != null && role.code) {
        if (role.code === "ND") return "primary";
        if (role.code === "LDTDV") return "warning";
        if (role.code === "LDTPB") return "success";
        if (role.code === "LDSNV") return "info";
        if (role.code === "ADMIN") return "danger";
        return "primary";
      }
      return "primary";
    };
    const resolveUserStatusVariant = (status) => {
      if (status === "01") return "success";
      if (status === "00") return "warning";
      if (status === "04") return "secondary";
      return "success";
    };
    return {
      resolveUserRoleVariant,
      resolveUserStatusVariant,
      getDataList,
      refUserListTable,
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refetchData,
      avatarText,

      // dataTable,
      // dataTableIsLoaded,
      // searchTerm,
    };
  },
};
</script>
